module.exports = __webpack_public_path__ + "assets/img/bora.a7fdcfc5.png";